export class MicroappFbsAccessoryReservationModel{
    startDate: Date;
    endDate: Date;
    title:string;
    description: string;
    userId: number;
    availableResourceIds: number[];
    numberToReserve: number
}